'use strict';

import React from 'react';
import PropTypes from 'prop-types';

export default class SelectYearTo extends React.Component {
  static propTypes = {
    startYear: PropTypes.number.isRequired,
    endYear: PropTypes.number.isRequired,
    defaultValue: PropTypes.string.isRequired,
    updater: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      value: props.defaultValue,
      startYear: props.startYear,
    };
  }

  componentDidMount() {
    this.props.updater.addListener('year_from_selected', this.listener);
  }

  componentWillUnmount() {
    this.props.updater.removeListener('year_from_selected');
  }

  listener = (value) => {
    if (value > this.state.value) {
      this.setState({ value: value, startYear: value });
    } else {
      this.setState({ startYear: value });
    }
  }

  handleChange = (e) => {
    const value = e.target.value;
    this.setState({ value: value });
  }

  optionsToSelect() {
    var options = [<option value="" key={0} />];
    for (var i = this.state.startYear; i < this.props.endYear; i++) {
      options.push(<option value={i} key={i}>{i}</option>);
    }
    return options;
  }

  render() {
    return (
      <select
        ref="select"
        value={this.state.value}
        className="form-control"
        name="race_category[year_born_to]"
        onChange={this.handleChange}>
        {this.optionsToSelect()}
      </select>
    );
  }
}
